import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import SectionRenderer from "../components/SectionRenderer";
import { useSEO } from "../lib/useSEO";
import { SEO } from "../lib/seoConfig";

const scrollToHashOrTop = (hash) => {
  if (hash) {
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
};

const Page = ({ path, sections }) => {
  const { pathname, hash } = useLocation();
  const seo = SEO[path] || SEO[pathname] || SEO["/"];
  useSEO({ ...seo, path: path || pathname });

  useEffect(() => {
    scrollToHashOrTop(hash);
  }, [pathname, hash]);

  return (
    <Layout>
      <SectionRenderer sections={sections} />
    </Layout>
  );
};

export default Page;
